import { html, TemplateElement } from '@webtides/element-js';
import style from './scroll-to-top.css';

export default class ScrollToTop extends TemplateElement {
    constructor() {
        super({ shadowRender: true, styles: [style] });

        this._lastScrollY = 0;
        this._calculateScrollPosition = true;
    }

    properties() {
        return {
            duration: 1000,
        };
    }

    connected() {
        this.removeAttribute('cloak');
    }

    events() {
        return {
            this: {
                click: () => {
                    this.scrollToTop();
                },
            },

            window: {
                scroll: () => {
                    if (!this._calculateScrollPosition) {
                        // don't toggle the button
                        return;
                    }

                    const { scrollY } = window;

                    this.toggleBackToTopButton(scrollY);

                    this._calculateScrollPosition = false;
                    this._lastScrollY = scrollY;

                    requestAnimationFrame(() => (this._calculateScrollPosition = true));
                },
            },
        };
    }

    shouldShowBackToTopButton(currentScrollY) {
        if (window.innerHeight + currentScrollY >= document.body.offsetHeight) {
            // bottom of page.
            return true;
        }

        if (scrollY > this._lastScrollY) {
            // scrolling down.
            return false;
        }

        // the user has left the initial viewport.
        return currentScrollY > window.innerHeight;
    }

    toggleBackToTopButton(currentScrollY) {
        const shouldShow = this.shouldShowBackToTopButton(currentScrollY);
        this.classList.toggle('back-to-top-show', shouldShow);
    }

    scrollToTop() {
        const htmlScroll = window
            .getComputedStyle(document.querySelectorAll('html')[0], null)
            .getPropertyValue('scroll-behavior');

        if (htmlScroll === 'smooth') {
            window.scrollTo(0, 0);
        } else {
            const duration = this.duration;
            const difference = document.documentElement.scrollTop || document.body.scrollTop;
            const startTime = performance.now();

            // noinspection JSAnnotator
            function step(timeStamp) {
                let normalizedTime = (timeStamp - startTime) / duration;
                if (normalizedTime > 1) normalizedTime = 1;

                window.scrollTo(0, difference * Math.cos(normalizedTime * Math.PI));
                if (normalizedTime < 1) window.requestAnimationFrame(step);
            }
            window.requestAnimationFrame(step);
        }
    }

    // prettier-ignore
    template() {
        return html`
            <slot></slot>
        `;
    }
}
